// #region appState
export const CHANGE_VIEW = 'CHANGE_VIEW';
export const OVERRIDE_BEFORE_UNLOAD = 'OVERRIDE_BEFORE_UNLOAD';
export const SET_PROTOCOLNAME = 'SET_PROTOCOLNAME';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const SET_SUMMARY_VIEW = 'SET_SUMMARY_VIEW';
export const SET_CURRENT_VOLUME = 'SET_CURRENT_VOLUME';
export const SHOW_PIPETTING_PARAMETERS = 'SHOW_PIPETTING_PARAMETERS';
export const HIDE_PIPETTING_PARAMETERS = 'HIDE_PIPETTING_PARAMETERS';
export const SET_IS_TOUCHPROBE_EXPANDED = 'SET_IS_TOUCHPROBE_EXPANDED';
export const SET_DESTINATION_LABWAREIDS = 'SET_DESTINATION_LABWAREIDS';
export const RESET_DESTINATION_LABWAREID = 'RESET_DESTINATION_LABWAREID';
export const RESET_ALL_PROTOCOL_TASK_EDITOR_STATE = 'RESET_ALL_PROTOCOL_TASK_EDITOR_STATE';
export const SET_DRAWER_VISIBILITY = 'SET_DRAWER_VISIBILITY';
export const RESTORE_APPSTATE = 'RESTORE_APPSTATE';
export const TRIGGER_REBUILD_CONNECTION = 'TRIGGER_REBUILD_CONNECTION';
export const SET_HEAD_CHANNELS_CONFIG_OPEN = 'SET_HEAD_CHANNELS_CONFIG_OPEN';
export const SET_IS_ANY_MODAL_SHOW = 'SET_IS_ANY_MODAL_SHOW';
export const SET_IS_MANUAL_RETEACH_PAGE = 'SET_IS_MANUAL_RETEACH_PAGE';
export const RESET_IS_MANUAL_RETEACH_PAGE = 'RESET_IS_MANUAL_RETEACH_PAGE';
export const SET_IS_RESTORING_SOFTWARE = 'SET_IS_RESTORING_SOFTWARE';
// #endregion appState

// #region config state
export const SET_CONFIG = 'SET_CONFIG';
// #endregion config state

// #region signalr state
export const SET_SESSION_CONNID = 'SET_SESSION_CONNID';
export const SET_SESSION_HUB = 'SET_SESSION_HUB';
export const SET_AUTHORING_HUB = 'SET_AUTHORING_HUB';
export const SET_STATE_HUB = 'SET_STATE_HUB';
export const SET_INSTRUMENT_HUB = 'SET_INSTRUMENT_HUB';
export const SET_TRAY_HUB = 'SET_TRAY_HUB';
export const SET_USER_MANAGEMENT_HUB = 'SET_USER_MANAGEMENT_HUB';
export const SET_LABWARE_DEFINITION_HUB = 'SET_LABWARE_DEFINITION_HUB';
export const SET_PROTOCOL_HUB = 'SET_PROTOCOL';
export const SET_PROTOCOL_MANAGEMENT_HUB = 'SET_PROTOCOL_MANAGEMENT_HUB';
export const SET_SOFTWARE_UPDATER_HUB = 'SET_SOFTWARE_UPDATER_HUB';
export const SET_HUB = 'SET_HUB';
export const SET_LATEST_SIGNAL_R_EVENT_RECEIVED = 'SET_LATEST_SIGNAL_R_EVENT_RECEIVED';
export const SET_BACKUP_AND_RESTORE_HUB = 'SET_BACKUP_AND_RESTORE_HUB';
// #endregion signalr state

// #region availableLabwareStateReducer
export const ADD_AVAILABLE_LABWARE = 'ADD_AVAILABLE_LABWARE';
export const ADD_INITIAL_LABWARE = 'ADD_INITIAL_LABWARE';
export const SET_RECENT_LABWARE = 'SET_RECENT_LABWARE';
export const RESTORE_AVAILABLELABWARESTATE = 'RESTORE_AVAILABLELABWARESTATE';
export const RESET_AVAILABLELABWARESTATE = 'RESET_AVAILABLELABWARESTATE';
// #endregion availableLabwareStateReducer

// #region labware state
export const SET_LABWARE_STATE = 'SET_LABWARE_STATE';
export const SET_LABWARE = 'SET_LABWARE';
export const REMOVE_LABWARE = 'REMOVE_LABWARE';
export const SWITCH_LABWARE = 'SWITCH_LABWARE';
export const SELECT_LABWARE = 'SELECT_LABWARE';
export const UNSELECT_LABWARE = 'UNSELECT_LABWARE';
export const UNSELECT_ALL_LABWARE = 'UNSELECT_ALL_LABWARE';
export const RENAME_LABWARE = 'RENAME_LABWARE';
export const RESTORE_LABWARESTATE = 'RESTORE_LABWARESTATE';
export const RESET_LABWARESTATE = 'RESET_LABWARESTATE';
export const SET_LABWARE_BARCODE = 'SET_LABWARE_BARCODE';
// #endregion labware state

// #region Dispense Report
export const SET_REPORT_PROTOCOL_NAME = 'SET_REPORT_PROTOCOL_NAME';
export const SET_REPORT_PROTOCOL_OWNER = 'SET_REPORT_PROTOCOL_OWNER';
export const SET_REPORT_PROTOCOL_RUN_BY = 'SET_REPORT_PROTOCOL_RUN_BY';
export const SET_REPORT_SUMMARY = 'SET_REPORT_SUMMARY';
export const SET_REPORT_SUMMARY_CSV = 'SET_REPORT_SUMMARY_CSV';
export const SET_REPORT_CREATED_TIME = 'SET_REPORT_CREATED_TIME';
export const RESTORE_REPORT_SUMMARY = 'RESTORE_REPORT_SUMMARY';
export const RESTORE_REPORT_ID = 'RESTORE_REPORT_ID';
export const SET_PREVIOUS_REPORT = 'SET_PREVIOUS_REPORT';
// #endregion Dispense Report

// #region ModalState
export const SET_APP_MODAL = 'SET_APP_MODAL';
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';
export const SET_MODAL_VALID = 'SET_MODAL_VALID';
export const SET_MODAL_INVALID = 'SET_MODAL_INVALID';
export const RESTORE_MODALSTATE = 'RESTORE_MODALSTATE';
export const RESET_MODALSTATE = 'RESET_MODALSTATE';
export const SET_TIMER_INTERVAL = 'SET_TIMER_INTERVAL';
export const CLEAR_TIMER_INTERVAL = 'CLEAR_TIMER_INTERVAL';
export const SET_MODAL_ERROR_CODE_NUMBER = 'SET_MODAL_ERROR_CODE_NUMBER';
export const CLEAR_MODAL_ERROR = 'CLEAR_MODAL_ERROR';
export const CLEAR_PREVIOUS_ERROR_MODAL = 'CLEAR_PREVIOUS_ERROR_MODAL';
export const SET_MODAL_TYPE = 'SET_MODAL_TYPE';
// #endregion ModalState

// #region user management
export const SET_AVAILABLE_ROLES = 'SET_AVAILABLE_ROLES';
export const SET_AVAILABLE_ROLE_RIGHTS = 'SET_AVAILABLE_ROLE_RIGHTS';
// #endregion user management

// #region Tray Calibration
export const SET_TRAY_ID = 'SET_TRAY_ID';
export const SET_TRAY_TYPE = 'SET_TRAY_TYPE';
export const SET_TRAY_DATA = 'SET_TRAY_DATA';
export const ADD_TRAY = 'ADD_TRAY';
export const ADD_DECK_INSERT = 'ADD_DECK_INSERT';
export const SET_DEFAULT_DECK_INSERT = 'SET_DEFAULT_DECK_INSERT';
export const SET_DECK_INSERT = 'SET_DECK_INSERT';

export const SET_DECK_INSERT_X_VALUE = 'SET_DECK_INSERT_X_VALUE';
export const SET_DECK_INSERT_Y_VALUE = 'SET_DECK_INSERT_Y_VALUE';
export const SET_DECK_INSERT_Z_VALUE = 'SET_DECK_INSERT_Z_VALUE';
export const SET_DECK_INSERT_XYZ_VALUE = 'SET_DECK_INSERT_XYZ_VALUE';
export const SET_DECK_INSERT_CALIBRATED = 'SET_DECK_INSERT_CALIBRATED';
export const SET_ROLL_PITCH_YAW = 'SET_ROLL_PITCH_YAW';
export const SET_THRESHOLD_RPY = 'SET_THRESHOLD_RPY';
export const SET_LAST_CALIBRATED = 'SET_LAST_CALIBRATED';
export const SELECT_DECK_INSERT_BY_ID = 'SELECT_DECK_INSERT_BY_ID';
export const RESET_TRAYCALIBRATION = 'RESET_TRAYCALIBRATION';
export const RESTORE_TRAYCALIBRATION_STATE = 'RESTORE_TRAYCALIBRATION_STATE';
export const SET_CURRENT_POSITION = 'SET_CURRENT_POSITION';
export const SET_IS_TRAY_ATTACHED = 'SET_IS_TRAY_ATTACHED';
// #endregion Tray Calibration

// #region modal set tray ID State
export const SHOW_MODAL_SET_TRAY_ID = 'SHOW_MODAL_SET_TRAY_ID';
export const HIDE_MODAL_SET_TRAY_ID = 'HIDE_MODAL_SET_TRAY_ID';
export const RESET_MODAL_SET_TRAY_ID = 'RESET_MODAL_SET_TRAY_ID';
// #endregion modal set tray ID State

// #region card
export const ADD_CARD = 'ADD_CARD';
export const ADD_CARD_TASK = 'ADD_CARD_TASK';
export const BATCH_ADD_CARD_TASK = 'BATCH_ADD_CARD_TASK';
export const INSERT_CARD_TASK = 'INSERT_CARD_TASK';
export const SET_IS_INSERT_CARD = 'SET_IS_INSERT_CARD';
export const REMOVE_CARD = 'REMOVE_CARD';
export const REMOVE_CARDS = 'REMOVE_CARDS';
export const REMOVE_CARD_TASK = 'REMOVE_CARD_TASK';
export const REMOVE_CARD_TASKS = 'REMOVE_CARD_TASKS';
export const REMOVE_ALL_CARD_TASKS = 'REMOVE_ALL_CARD_TASKS';
export const SET_CARD_NAME = 'SET_CARD_NAME';
export const RESTORE_CARDSTATE = 'RESTORE_CARDSTATE';
export const RESTORE_CARDSTATE_BY_ID = 'RESTORE_CARDSTATE_BY_ID';
export const BATCH_RESTORE_CARDSTATE_BY_ID = 'BATCH_RESTORE_CARDSTATE_BY_ID';
export const RESTORE_CARDTASKSTATE = 'RESTORE_CARDTASKSTATE';
export const RESTORE_CARDTASKSTATE_BY_ID = 'RESTORE_CARDTASKSTATE_BY_ID';
export const BATCH_RESTORE_CARDTASKSTATE_BY_ID = 'BATCH_RESTORE_CARDTASKSTATE_BY_ID';
export const RESET_CARDSTATE = 'RESET_CARDSTATE';
export const RESET_CARDTASKSTATE = 'RESET_CARDTASKSTATE';
export const SET_IGNORE_CARD = 'SET_IGNORE_CARD';
export const SET_IGNORE_CARD_TASK = 'SET_IGNORE_CARD_TASK';
export const ADD_CARD_INVALID_TYPE = 'ADD_CARD_INVALID_TYPE';
export const REMOVE_CARD_INVALID_TYPE = 'REMOVE_CARD_INVALID_TYPE';
export const SET_TASK_NUMBER = 'SET_TASK_NUMBER';
export const SET_TASK_ROW = 'SET_TASK_ROW';
export const SET_TASK_COLUMN = 'SET_TASK_COLUMN';
export const SET_TASK_ROW_TIP_COUNT = 'SET_TASK_ROW_TIP_COUNT';
export const SET_TASK_COLUMN_TIP_COUNT = 'SET_TASK_COLUMN_TIP_COUNT';
export const SET_TASK_LABWARE = 'SET_TASK_LABWARE';
export const SET_TASK_LABWARE_INDEX = 'SET_TASK_LABWARE_INDEX';
export const SET_TASK_TIP_POSITION = 'SET_TASK_TIP_POSITION';
export const SET_TASK_MIXING_POSITION = 'SET_TASK_MIXING_POSITION';
export const SET_TASK_ENABLE_MIXING = 'SET_TASK_ENABLE_MIXING';
export const SET_TASK_MIXING_CYCLE = 'SET_TASK_MIXING_CYCLE';
export const SET_TASK_MIXING_VOLUME = 'SET_TASK_MIXING_VOLUME';
export const SET_TASK_MIXING_POSITION_ASPIRATE = 'SET_TASK_MIXING_POSITION_ASPIRATE';
export const SET_TASK_MIXING_POSITION_DISPENSE = 'SET_TASK_MIXING_POSITION_DISPENSE';
export const SET_TASK_SPEED = 'SET_TASK_SPEED';
export const SET_TASK_RETRACT_SPEED = 'SET_TASK_RETRACT_SPEED';
export const SET_TASK_MIXING_SPEED = 'SET_TASK_MIXING_SPEED';
export const SET_TASK_PRECISION_DISPENSE = 'SET_TASK_PRECISION_DISPENSE';
export const SET_TASK_VOLUME = 'SET_TASK_VOLUME';
export const SET_TASK_TIP_TOUCH_OFF = 'SET_TASK_TIP_TOUCH_OFF';
export const SET_TASK_TIP_TOUCH_OFF_DELAY = 'SET_TASK_TIP_TOUCH_OFF_DELAY';
export const SET_TASK_TIP_TOUCH_OFF_HEIGHT = 'SET_TASK_TIP_TOUCH_OFF_HEIGHT';
export const SET_TASK_TIP_TOUCH_OFF_DIRECTION_X = 'SET_TASK_TIP_TOUCH_OFF_DIRECTION_X';
export const SET_TASK_TIP_TOUCH_OFF_DIRECTION_Y = 'SET_TASK_TIP_TOUCH_OFF_DIRECTION_Y';
export const SET_TASK_DISPENSE_AT_WELL_SIDE = 'SET_TASK_DISPENSE_AT_WELL_SIDE';
export const SET_TASK_IS_SELECTED = 'SET_TASK_IS_SELECTED';
export const BATCH_SET_TASKS_LOCATION = 'BATCH_SET_TASKS_LOCATION';
export const SET_MULTIPLE_TASK_IS_SELECTED = 'SET_MULTIPLE_TASK_IS_SELECTED';
export const SET_ALL_TASK_IS_SELECTED = 'SET_ALL_TASK_IS_SELECTED';
export const SWAP_CARD_POSITION = 'SWAP_CARD_POSITION';
export const SWAP_TASK_ITEM_POSITION = 'SWAP_TASK_ITEM_POSITION';
export const SET_CARD_IS_SELECTED = 'SET_CARD_IS_SELECTED';
export const SET_ALL_CARD_IS_SELECTED = 'SET_ALL_CARD_IS_SELECTED';
export const SAVE_NORMALIZATION_STATE_TO_CARD = 'SAVE_NORMALIZATION_STATE_TO_CARD';
export const CHANGE_BULK_CARD_TASK = 'CHANGE_BULK_CARD_TASK';
export const SET_CARD_IS_EXPANDED = 'SET_CARD_IS_EXPANDED';
export const ADD_CARD_BY_OBJECT = 'ADD_CARD_BY_OBJECT';
export const ADD_CARD_GROUP = 'ADD_CARD_GROUP';
export const UNGROUP_CARD_GROUP = 'UNGROUP_CARD_GROUP';
export const REMOVE_CARD_GROUP = 'REMOVE_CARD_GROUP';
export const BATCH_REMOVE_CARD_GROUP = 'BATCH_REMOVE_CARD_GROUP';
export const REMOVE_CARD_GROUP_CARDS = 'REMOVE_CARD_GROUP_CARDS';
export const SET_CARD_GROUP_NAME = 'SET_CARD_GROUP_NAME';
export const RESTORE_GROUPSTATE = 'RESTORE_GROUPSTATE';
export const RESET_GROUPSTATE = 'RESET_GROUPSTATE';
export const SET_GROUP_IS_SELECTED = 'SET_GROUP_IS_SELECTED';
export const SET_GROUP_IS_EXPANDED = 'SET_GROUP_IS_EXPANDED';
export const SET_GROUP_IS_ALL_EXPANDED = 'SET_GROUP_IS_ALL_EXPANDED';
export const SET_ALL_GROUP_IS_SELECTED = 'SET_ALL_GROUP_IS_SELECTED';
export const SET_TIP_X_POSITION_OFFSET = 'SET_TIP_X_POSITION_OFFSET';
export const SET_TIP_Y_POSITION_OFFSET = 'SET_TIP_Y_POSITION_OFFSET';
export const SET_HUMIDITY_LEVEL = 'SET_HUMIDITY_LEVEL';

export const CardStateType = {
  GROUP_ADD_CARD_LIST: 'cardState/groups/GROUP_ADD_CARD_LIST',

  BATCH_ADD_TASKS: 'cardState/tasks/BATCH_ADD_TASKS',
};
// #endregion card

// #region card - serial dilution
export const ADD_SD_CARD = 'ADD_SD_CARD';
export const ADD_SD_RAW_TASK = 'ADD_SD_RAW_TASK';
export const ADD_SD_RAW_TASKS_DILUENT_TARGET = 'ADD_SD_RAW_TASKS_DILUENT_TARGET';
export const REMOVE_SD_RAW_TASK = 'REMOVE_SD_RAW_TASK';
export const REMOVE_SD_DILUENT_TARGET_RAW_TASK = 'REMOVE_SD_DILUENT_TARGET_RAW_TASK';
export const SET_IGNORE_SD_RAW_TASK = 'SET_IGNORE_SD_RAW_TASK';
export const RESTORE_CARD_SDRAWTASKSTATE_BY_ID = 'RESTORE_CARD_SDRAWTASKSTATE_BY_ID';
export const RESTORE_CARD_SDRAWTASKSTATE = 'RESTORE_CARD_SDRAWTASKSTATE';
export const SET_SD_RAW_TASK_SUMMARY_SAMPLE_SOURCE = 'SET_SD_RAW_TASK_SUMMARY_SAMPLE_SOURCE';
export const SET_SD_RAW_TASK_SUMMARY_SAMPLE_TARGET = 'SET_SD_RAW_TASK_SUMMARY_SAMPLE_TARGET';
export const SET_SD_RAW_TASK_SUMMARY_DILUENT_SOURCE = 'SET_SD_RAW_TASK_SUMMARY_DILUENT_SOURCE';
export const SET_SD_RAW_TASK_SUMMARY_DILUENT_TARGETS = 'SET_SD_RAW_TASK_SUMMARY_DILUENT_TARGETS';
export const SET_CARD_SD_PROPERTY = 'SET_CARD_SD_PROPERTY';
export const SET_SD_STEP_PROPERTIES_OBJECT = 'SET_SD_STEP_PROPERTIES_OBJECT';
export const SET_SD_PROPERTY_OBJECT = 'SET_SD_PROPERTY_OBJECT';
export const REMOVE_SD_PROPERTY_OBJECT = 'REMOVE_SD_PROPERTY_OBJECT';
export const SET_SD_RAW_TASK_IS_SELECTED = 'SET_SD_RAW_TASK_IS_SELECTED';
export const SET_SD_REPLICATE_WELL = 'SET_SD_REPLICATE_WELL';
export const SerialDilutionAction = {
  SET_SD_RAW_TASKS_SUMMARY: 'serialDilutionAction/SET_SD_RAW_TASKS_SUMMARY',
};
// #endregion card - serial dilution

// #region card - broadcast
export const SET_BROADCAST_VOLUME = 'SET_BROADCAST_VOLUME';
export const SET_CARD_REUSE_TIP = 'SET_CARD_REUSE_TIP';
// #endregion card - broadcast

// #region card - pooling
export const SET_POOLING_VOLUME = 'SET_POOLING_VOLUME';
// #endregion card - pooling

// #region session
export const SET_SESSION_USER = 'SET_SESSION_USER';
export const SET_SESSION_ID = 'SET_SESSION_ID';
export const RESET_SESSION_STATE = 'RESET_SESSION_STATE';
// #endregion session

// #region Tip State
export const SET_TIP_STATE = 'SET_TIP_STATE';
export const SET_TIP_AMOUNT = 'SET_TIP_AMOUNT';
export const SELECT_TIP_COLUMN = 'SELECT_TIP_COLUMN';
export const RESET_TIP_SELECTION = 'RESET_TIP_SELECTION';
export const DESELECT_TIP_COLUMN = 'DESELECT_TIP_COLUMN';
export const SET_SELECTED_TIP_COLUMN = 'SET_SELECTED_TIP_COLUMN';
export const SET_SELECTED_TIP_QUADRANT = 'SET_SELECTED_TIP_QUADRANT';
export const SET_SELECTED_TIP = 'SET_SELECTED_TIP';
export const SET_PREV_SELECTED_TIP = 'SET_PREV_SELECTED_TIP';
export const SET_IS_ALREADY_UNDO = 'SET_IS_ALREADY_UNDO';
export const SELECT_TIP_QUADRANT = 'SELECT_TIP_QUADRANT';
export const DESELECT_TIP_QUADRANT = 'DESELECT_TIP_QUADRANT';
export const RESTORE_TIP_STATE = 'RESTORE_TIP_STATE';
export const SET_SHOW_SET_TIP_MODAL = 'SET_SHOW_SET_TIP_MODAL';
export const SET_PREV_ERROR_SET_TIP_MODAL = 'SET_PREV_ERROR_SET_TIP_MODAL';
// #endregion Tip State

// #region protocol
export const RESET_PROTOCOL_STATE = 'RESET_PROTOCOL_STATE';
export const RESTORE_PROTOCOL_STATE = 'RESTORE_PROTOCOL_STATE';
export const SET_AVAILABLE_PROTOCOLS = 'SET_AVAILABLE_PROTOCOLS';
export const SET_LAST_OPENED_PROTOCOL = 'SET_LAST_OPENED_PROTOCOL';
export const SET_LAST_SAVED_PROTOCOL_STATE = 'SET_LAST_SAVED_PROTOCOL_STATE';
export const SET_TEMPORARY_UNSAVED_PROTOCOL_DATA = 'SET_TEMPORARY_UNSAVED_PROTOCOL_DATA';
export const SET_OPENED_PROTOCOL_EJECT_TO_CADDY = 'SET_OPENED_PROTOCOL_EJECT_TO_CADDY';

export const ProtocolStateActionTypes = {
  SET_FAVORITE_PROTOCOLS: 'ProtocolStateActionTypes/SET_FAVORITE_PROTOCOLS',
};
// #endregion protocol

// #region Protocol Explorer State
export const RESET_PROTOCOL_EXPLORER_STATE = 'RESET_PROTOCOL_EXPLORER_STATE';
export const SET_PROTOCOL_CLIPBOARD_EVENT_TYPE = 'SET_PROTOCOL_CLIPBOARD_EVENT_TYPE';
export const SET_PROTOCOL_CLIPBOARD_ITEMS = 'SET_PROTOCOL_CLIPBOARD_ITEMS';
export const RESET_PROTOCOL_CLIPBOARD = 'RESET_PROTOCOL_CLIPBOARD';
export const SET_PROTOCOL_EXPLORER_RUNNING_PROTOCOL = 'SET_PROTOCOL_STATE_RUNNING_PROTOCOL';
export const SET_CURRENT_PROTOCOL_FOLDER = 'SET_CURRENT_PROTOCOL_FOLDER';
export const SET_PROTOCOL_EXPLORER_EXPANDED_GROUPS = 'SET_PROTOCOL_EXPLORER_EXPANDED_GROUPS';
export const SET_PROTOCOL_FOLDER_LIST = 'SET_PROTOCOL_FOLDER_LIST';
export const SET_SELECTED_PROTOCOL_OR_FOLDER = 'SET_SELECTED_PROTOCOL_OR_FOLDER';
export const SET_DEFAULT_VIEW_SETTINGS = 'SET_DEFAULT_VIEW_SETTINGS';
export const RESET_SELECTED_PROTOCOL_OR_FOLDER = 'RESET_SELECTED_PROTOCOL_OR_FOLDER';
export const SET_PROTOCOL_EXPLORER_ITEMS = 'SET_PROTOCOL_EXPLORER_ITEMS';
export const SET_TRAY_BOUND_PROTOCOL_IDS = 'SET_TRAY_BOUND_PROTOCOL_IDS';
export const SET_PROTOCOL_EXPLORER_FILTER = 'SET_PROTOCOL_EXPLORER_FILTERS';
export const SET_PROTOCOL_EXPLORER_ACTIVE_SORT = 'SET_PROTOCOL_EXPLORER_ACTIVE_SORT';
// #endregion

// #region Runtime State
export const SET_RUNTIME_PROTOCOL_ID = 'SET_RUNTIME_PROTOCOL_ID';
export const SET_RUNTIME_PROTOCOL_NAME = 'SET_RUNTIME_PROTOCOL_NAME';
export const SET_RUNTIME_STATUS = 'SET_RUNTIME_STATUS';
export const SET_RUNTIME_TYPE = 'SET_RUNTIME_TYPE';
export const SET_RUNTIME_PROGRESS = 'SET_RUNTIME_PROGRESS';
export const SET_RUNTIME_PAUSE_REMAINING_TIME = 'SET_PAUSE_REMAINING_TIME';
export const SET_RUNTIME_REMAINING_TIME = 'SET_RUNTIME_REMAINING_TIME';
export const SET_RUNTIME_TESSARA_PROTOCOL = 'SET_RUNTIME_TESSARA_PROTOCOL';
export const SET_CSV_RECORD_ID = 'SET_CSV_RECORD_ID';
export const SHOW_RUNTIME_DIALOG = 'SHOW_RUNTIME_DIALOG';
export const HIDE_RUNTIME_DIALOG = 'HIDE_RUNTIME_DIALOG';
export const SET_RUNTIME_TRAY_TYPE = 'SET_RUNTIME_TRAY_TYPE';

export const SET_PAUSED_ON = 'SET_PAUSED_ON';
export const ADD_ON_PROGRESS_RECORD = 'ADD_ON_PROGRESS_RECORD';
export const REMOVE_ON_PROGRESS_RECORD = 'REMOVE_ON_PROGRESS_RECORD';
export const ADD_DONE_RECORD = 'ADD_DONE_RECORD';
export const SET_ABORT_PARAM = 'SET_ABORT_PARAM';
export const SET_DONE_DISPENS_WELL_POS = 'SET_DONE_DISPENS_WELL_POS';
export const RESTORE_RUNTIMESTATE = 'RESTORE_RUNTIMESTATE';
export const RESET_RUNTIMESTATE = 'RESET_RUNTIMESTATE';

export const SET_RUNTIME_REPORT_VISIBLE = 'SET_RUNTIME_REPORT_VISIBLE';
export const SET_READ_ONLY = 'SET_READ_ONLY';
export const SET_RUNTIME_USER = 'SET_RUNTIME_USER';
export const SET_RUNTIME_ABORT_USER_REQUESTER = 'SET_RUNTIME_ABORT_USER_REQUESTER';

export const RuntimeStateType = {
  SET_EXECUTION_COUNT: 'runtimeState/SET_EXECUTION_COUNT',
};

// #endregion Runtime State */

// #region plate type editor
export const PTE_SET_CURRENT_WIZARD_VIEW = 'PTE_SET_CURRENT_WIZARD_VIEW';
export const PTE_INCREMENT_CURRENT_WIZARD_VIEW = 'PTE_INCREMENT_CURRENT_WIZARD_VIEW';
export const PTE_DECREMENT_CURRENT_WIZARD_VIEW = 'PTE_DECREMENT_CURRENT_WIZARD_VIEW';
export const PTE_SET_ALLOWED_TO_NEXT = 'PTE_SET_ALLOWED_TO_NEXT';
export const PTE_SET_PROCESSED_STEP = 'PTE_SET_PROCESSED_STEP';
export const PTE_SET_WELL_NUMBER = 'PTE_SET_WELL_NUMBER';
export const PTE_SET_WELL_LABEL = 'PTE_SET_WELL_LABEL';
export const PTE_SET_WELL_BOTTOM_PROFILE = 'PTE_SET_WELL_BOTTOM_PROFILE';
export const PTE_SET_WELL_SHAPE = 'PTE_SET_WELL_SHAPE';
export const PTE_SET_PLATE_NAME = 'PTE_SET_PLATE_NAME';
export const PTE_SET_PLATE_TYPE = 'PTE_SET_PLATE_TYPE';
export const PTE_SET_PART_NUMBER = 'PTE_SET_PART_NUMBER';
export const PTE_SET_VENDOR = 'PTE_SET_VENDOR';
export const PTE_SET_NOTES = 'PTE_SET_NOTES';
export const PTE_SET_HEIGHT = 'PTE_SET_HEIGHT';
export const PTE_SET_DEPTH = 'PTE_SET_DEPTH';
export const PTE_SET_WIDTH = 'PTE_SET_WIDTH';
export const PTE_SET_LENGTH = 'PTE_SET_LENGTH';
export const PTE_SET_COLUMN_ORIGIN = 'PTE_SET_COLUMN_ORIGIN';
export const PTE_SET_ROW_ORIGIN = 'PTE_SET_ROW_ORIGIN';
export const PTE_SET_COLUMN_PITCH = 'PTE_SET_COLUMN_PITCH';
export const PTE_SET_ROW_PITCH = 'PTE_SET_ROW_PITCH';
export const PTE_SET_CAPACITY = 'PTE_SET_CAPACITY';
export const PTE_SET_WORKING_VOLUME = 'PTE_SET_WORKING_VOLUME';
export const PTE_SET_LAST_PROCESSED_ID = 'PTE_SET_LAST_PROCESSED_ID';
export const PTE_SET_COL_PITCH_ASSAY_SAMPLE = 'PTE_SET_COL_PITCH_ASSAY_SAMPLE';
export const PTE_SET_TROUGH_DEPTH = 'PTE_SET_TROUGH_DEPTH';
export const RESTORE_PLATE_TYPE_EDITOR_STATE = 'RESTORE_PLATE_TYPE_EDITOR_STATE';
export const RESET_PLATE_TYPE_EDITOR_STATE = 'RESET_PLATE_TYPE_EDITOR_STATE';
export const SET_PTE_EDIT_MODE = 'SET_PTE_EDIT_MODE';
export const SET_PTE_EJECT_TRAY = 'SET_PTE_EJECT_TRAY';
// #endregion plate type editor

// #region Normalization
export const SET_CURRENT_WIZARD_VIEW = 'SET_CURRENT_WIZARD_VIEW';
export const INCREMENT_CURRENT_WIZARD_VIEW = 'INCREMENT_CURRENT_WIZARD_VIEW';
export const DECREMENT_CURRENT_WIZARD_VIEW = 'DECREMENT_CURRENT_WIZARD_VIEW';
export const SET_ALLOWED_TO_NEXT = 'SET_ALLOWED_TO_NEXT';
export const SET_CSV_FILE_NAME = 'SET_CSV_FILE_NAME';
export const SET_CSV_RAW_DATA = 'SET_CSV_RAW_DATA';
export const SET_CSV_DATA = 'SET_CSV_DATA';
export const SET_CSV_TOTAL_ROW = 'SET_CSV_TOTAL_ROW';
export const SET_CSV_DELIMITER = 'SET_CSV_DELIMITER';
export const SET_CSV_START_ROW = 'SET_CSV_START_ROW';
export const SET_CSV_COLUMN_IN_FIRST_ROW = 'SET_CSV_COLUMN_IN_FIRST_ROW';
export const SET_WELL_INCREMENT_PATTERN = 'SET_WELL_INCREMENT_PATTERN';
export const SET_NORMALIZATION_SELECTED_LABWARE = 'SET_NORMALIZATION_SELECTED_LABWARE';
export const SET_SELECTED_COLUMN_INDEX = 'SET_SELECTED_COLUMN_INDEX';
export const SET_TARGET_CONCENTRATION = 'SET_TARGET_CONCENTRATION';
export const SET_LOWEST_CONCENTRATION = 'SET_LOWEST_CONCENTRATION';
export const SET_NORMALIZATION_CURRENT_VOLUME = 'SET_NORMALIZATION_CURRENT_VOLUME';
export const SET_REAGENT_NAME = 'SET_REAGENT_NAME';
export const SET_DILUENT_NAME = 'SET_DILUENT_NAME';
export const SET_PREVIEW_DATA = 'SET_PREVIEW_DATA';
export const RESTORE_NORMALIZATION_STATE = 'RESTORE_NORMALIZATION_STATE';
export const RESET_NORMALIZATION_STATE = 'RESET_NORMALIZATION_STATE';
export const SET_DILUENT_LABWARE_ID = 'SET_DILUENT_LABWARE_ID';
export const SET_DILUENT_WELL = 'SET_DILUENT_WELL';
export const RESET_NORMALIZATION_CURRENT_VOLUME = 'RESET_NORMALIZATION_CURRENT_VOLUME';
export const SET_DEFAULT_TARGET_CONCENTRATION = 'SET_DEFAULT_TARGET_CONCENTRATION';
export const RESET_DEFAULT_CURRENT_VOLUME = 'RESET_DEFAULT_CURRENT_VOLUME';
export const SET_NORMALIZATION_TYPE = 'SET_NORMALIZATION_TYPE';
export const SET_NORMALIZATION_DILUENT_LABWARE = 'SET_NORMALIZATION_DILUENT_LABWARE';
// #endregion Normalization

// #region Temporary State
export const ADD_TEMPORARY_STATE = 'ADD_TEMPORARY_STATE';
export const REMOVE_TEMPORARY_STATE = 'REMOVE_TEMPORARY_STATE';
export const RESET_TEMPORARY_STATE = 'RESET_TEMPORARY_STATE';
export const RESTORE_TEMPORARY_STATE = 'RESTORE_TEMPORARY_STATE';
// #endregion Temporary State

// #region color

export const SET_COLOR_PALETTE = 'SET_COLOR_PALETTE';

// #endregion

// #region Protocol Editor State
export const SET_CURRENT_TIP_VOLUME = 'SET_CURRENT_TIP_VOLUME';
export const SET_SELECTED_TIP_CHANNEL = 'SET_SELECTED_TIP_CHANNEL';
export const SET_SELECTED_LABWAREID = 'SET_SELECTED_LABWAREID';
export const SET_CUSTOM_TIP_COUNT = 'SET_CUSTOM_TIP_COUNT';
export const SET_SELECTED_MENU = 'SET_SELECTED_MENU';
export const SET_SERIAL_DILUTION_STEP = 'SET_SERIAL_DILUTION_STEP';
export const SET_SERIAL_DILUTION_EDIT_STEP = 'SET_SERIAL_DILUTION_EDIT_STEP';
export const SET_SERIAL_DILUTION_PREV_STEP = 'SET_SERIAL_DILUTION_PREV_STEP';
export const SET_SERIAL_DILUTION_SET_ALL_SAMPLE = 'SET_SERIAL_DILUTION_SET_ALL_SAMPLE';
export const SET_OPEN_SD_PREVIEW = 'SET_OPEN_SD_PREVIEW';
export const SET_BROADCAST_TASK_EDIT_STEP = 'SET_BROADCAST_TASK_EDIT_STEP';
export const RESET_PROTOCOL_EDITOR_STATE = 'RESET_PROTOCOL_EDITOR_STATE';
export const RESTORE_PROTOCOL_EDITOR_STATE = 'RESTORE_PROTOCOL_EDITOR_STATE';
export const SET_POOLING_TASK_EDIT_STEP = 'SET_POOLING_TASK_EDIT_STEP';
export const SET_POOLING_TASK_STEP = 'SET_POOLING_TASK_STEP';
export const SET_CURRENT_TIP_VOLUME_NEXT_STATE = 'SET_CURRENT_TIP_VOLUME_NEXT_STATE';
export const SET_CURRENT_TIP_VOLUME_PREV_STATE = 'SET_CURRENT_TIP_VOLUME_PREV_STATE';
export const SET_NORMALIZATION_TASK_EDIT_STEP = 'SET_NORMALIZATION_TASK_EDIT_STEP';
export const SET_IS_EDIT_MIXING = 'SET_IS_EDIT_MIXING';
export const SET_VOLUME_MODAL_OPEN = 'SET_VOLUME_MODAL_OPEN';
export const SET_ASPIRATE_DISPENSE_MODAL_SHOWN = 'SET_ASPIRATE_DISPENSE_MODAL_SHOWN';
export const SET_COPIED_PIPETTING_PARAMETER = 'SET_COPIED_PIPETTING_PARAMETER';
export const RESET_COPIED_PIPETTING_PARAMETER = 'RESET_COPIED_PIPETTING_PARAMETER';
export const SET_SIMPLE_TRANSFER_EDITED_TYPE = 'SET_SIMPLE_TRANSFER_EDITED_TYPE';
export const ENABLE_AUTO_SAVE = 'ENABLE_AUTO_SAVE';
export const DISABLE_AUTO_SAVE = 'DISABLE_AUTO_SAVE';
export const SET_PENDING_SAVE_EXIST = 'SET_PENDING_SAVE_EXIST';
// #endregion

// #region undo redo state

export const UNDO_REDO_STATE_UNDO_ITEM = 'UNDO_REDO_STATE_UNDO_ITEM';
export const UNDO_REDO_STATE_REDO_ITEM = 'UNDO_REDO_STATE_REDO_ITEM';
export const UNDO_REDO_STATE_NEW_ITEM = 'UNDO_REDO_STATE_NEW_ITEM';
export const UNDO_REDO_STATE_RESTORE_ITEM = 'UNDO_REDO_STATE_RESTORE_ITEM';
export const UNDO_REDO_STATE_CLEAR_ITEM = 'UNDO_REDO_STATE_CLEAR_ITEM';
export const UNDO_REDO_STATE_RESTORE_ALL = 'UNDO_REDO_STATE_RESTORE_ALL';
export const UNDO_REDO_STATE_RESET = 'UNDO_REDO_STATE_RESET';
export const UNDO_REDO_UPDATE_PRESENT_ITEM = 'UNDO_REDO_UPDATE_PRESENT_ITEM';

// #endregion undo redo state

// #region about state
export const SET_SYSTEM_INFORMATION_DATA = 'SET_SYSTEM_INFORMATION_DATA';
export const SET_IS_UPDATING = 'SET_IS_UPDATING';
export const SET_IS_DOWNGRADING = 'SET_IS_DOWNGRADING';
export const SET_IS_FINALIZING = 'SET_IS_FINALIZING';

// #endregion about state

// #region license state
export const SHOW_LICENSE_MODAL = 'SHOW_LICENSE_MODAL';
export const HIDE_LICENSE_MODAL = 'HIDE_LICENSE_MODAL';
export const SET_LICENSE = 'SET_LICENSE';
export const SHOW_LICENSE_COUNTDOWN = 'SHOW_LICENSE_COUNTDOWN';
export const HIDE_LICENSE_COUNTDOWN = 'HIDE_LICENSE_COUNTDOWN';
export const SET_TESSARA_LICENSE = 'SET_TESSARA_LICENSE';
// #endregion license state

// #region wizard state
export const WIZARD_SET_CURRENT_WIZARD_VIEW = 'WIZARD_SET_CURRENT_WIZARD_VIEW';
export const WIZARD_INCREMENT_CURRENT_WIZARD_VIEW = 'WIZARD_INCREMENT_CURRENT_WIZARD_VIEW';
export const WIZARD_DECREMENT_CURRENT_WIZARD_VIEW = 'WIZARD_DECREMENT_CURRENT_WIZARD_VIEW';
export const SET_PROCESSED_STEP = 'SET_PROCESSED_STEP';
export const INCREMENT_PROCESSED_STEP = 'INCREMENT_PROCESSED_STEP';
export const DECREMENT_PROCESSED_STEP = 'DECREMENT_PROCESSED_STEP';
export const STATE_WIZARD_RESET = 'STATE_WIZARD_RESET';
export const RESTORE_WIZARD_STATE = 'RESTORE_WIZARD_STATE';
export const SET_WIZARD_VIEW_DATA = 'SET_WIZARD_VIEW_DATA';
export const SET_WIZARD_STATUS = 'SET_WIZARD_STATUS';
export const SET_IS_WIZARD_ALLOWED_NEXT = 'SET_IS_WIZARD_ALLOWED_NEXT';
export const SET_WIZARD_FLAG = 'SET_WIZARD_FLAG';
export const SET_WIZARD_STEP_DATA = 'SET_WIZARD_STEP_DATA';
export const SET_WIZARD_CURRENT_STEP_DATA = 'SET_WIZARD_CURRENT_STEP_DATA';
export const SET_WIZARD_STEP_NAME = 'SET_WIZARD_STEP_NAME';
export const SET_WIZARD_INITIAL_TRAY_TYPE = 'SET_WIZARD_INITIAL_TRAY_TYPE';
export const SET_AUTO_A1_OFFSET_CALLIBRATION_PROGRESS = 'SET_AUTO_A1_OFFSET_CALLIBRATION_PROGRESS';
// #endregion wizard state

// #region Reteach Plate State
export const ReteachPlate = {
  SET_RETEACH_PLATES: 'reteachPlateState/SET_RETEACH_PLATES',
  SET_MANUAL_RETEACH_CURRENT_INFO: 'reteachPlateState/SET_MANUAL_RETEACH__CURRENT_INFO',
  SET_MANUAL_RETEACH_CURRENT_POSITION: 'reteachPlateState/SET_MANUAL_RETEACH_CURRENT_POSITION',
  SET_LAST_VIEW_MODE: 'reteachPlateState/SET_LAST_VIEW_MODE',
  SET_MOVE_MOTION_CONTROL: 'reteachPlateState/SET_MOVE_MOTION_CONTROL',
  SET_SELECTED_WELL_STYLE: 'reteachPlateState/SET_SELECTED_WELL_STYLE',
  SET_RETURN_TO_CADDY: 'reteachPlateState/SET_RETURN_TO_CADDY',
  RESET_RETEACH_PLATE: 'reteachPlateState/RESET_RETEACH_PLATE',
  RESET_MANUAL_RETEACH_PLATE: 'reteachPlateState/RESET_MANUAL_RETEACH_PLATE',
  REMOVE_UPDATED_PLATE: 'reteachPlateState/REMOVE_UPDATED_PLATE',
  RESTORE_STATE: 'reteachPlateState/RESTORE_STATE',
};
// #endregion Reteach Plate State

// #region User Preference State
export const UserPreferenceType = {
  SET_FAVORITE_LABWARE_IDS: 'UserPreferenceState/SET_FAVORITE_LABWARE_IDS',
};
// #endregion User Preference State

// #region modal component state
export const TypedModalActionTypes = {
  SHOW_TYPED_MODAL: 'ModalComponentState/SHOW_TYPED_MODAL',
  HIDE_TYPED_MODAL: 'ModalComponentState/HIDE_TYPED_MODAL',
  SET_MODAL_DATA: 'ModalComponentState/SET_MODAL_DATA',
  RESET_MODAL_DATA: 'ModalComponentState/RESET_MODAL_DATA',
};
// #endRegion modal component state

// #region User Preference State
export const VirtualTrayActionTypes = {
  SET_FOCUSED_DECK_NUMBER: 'VirtualTrayActionTypes/SET_FOCUSED_DECK_NUMBER',
  SET_DECK_LABWARE_REFS: 'VirtualTrayActionTypes/SET_DECK_LABWARE_REFS',
  SET_ASP_DISP_VOLUME_MODAL: 'VirtualTrayActionTypes/SET_ASP_DISP_VOLUME_MODAL',
  SET_SHOWN_MODAL: 'VirtualTrayActionTypes/SET_SHOWN_MODAL',
  RESET_ASP_DISP_VOLUME_MODAL: 'VirtualTrayActionTypes/RESET_ASP_DISP_VOLUME_MODAL',
  RESTORE_VIRTUAL_TRAY_STATE: 'VirtualTrayActionTypes/RESTORE_VIRTUAL_TRAY_STATE',
  RESET_VIRTUAL_TRAY_STATE: 'VirtualTrayActionTypes/RESET_VIRTUAL_TRAY_STATE',
};
// #endregion User Preference State

// #region Task List State
export const TaskListActionTypes = {
  SET_SELECTED_TASKS: 'taskListActionTypes/SET_SELECTED_TASKS',
  REMOVE_SELECTED_TASKS: 'taskListActionTypes/REMOVE_SELECTED_TASKS',
  RESET_SELECTED_TASKS: 'taskListActionTypes/RESET_SELECTED_TASKS',
  SET_CARD_EXPANDED: 'taskListActionTypes/SET_CARD_EXPANDED',
  ADD_SELECTED_CARDS: 'taskListActionTypes/ADD_SELECTED_CARDS',
  REMOVE_SELECTED_CARDS: 'taskListActionTypes/REMOVE_SELECTED_CARDS',
  RESET_SELECTED_CARDS: 'taskListActionTypes/RESET_SELECTED_CARDS',
};
// #endregion Task List State

// #region Head State
export const HeadStateActionTypes = {
  SET_TIPS_PICKUP_POSITION: 'headStateActionTypes/SET_TIPS_PICKUP_POSITION',
  SET_TIPS_PICKUP_POSITION_LAST_CALIBRATED_DATE: 'headStateActionTypes/SET_TIPS_PICKUP_POSITION_LAST_CALIBRATED_DATE',
  SET_TIPS_PICKUP_IS_RECENTLY_CALIBRATED: 'headStateActionTypes/SET_TIPS_PICKUP_IS_RECENTLY_CALIBRATED',
  RESET_STATE: 'headStateActionTypes/RESET_STATE',
};
// #endregion Head State

// #region humidifier
export const HumidifierActionTypes = {
  SET_IS_HUMIDIFIER_INSTALLED: 'humidifierActionTypes/SET_IS_HUMIDIFIER_INSTALLED',
  SET_IDLE_HUMIDITY: 'humidifierActionTypes/SET_IDLE_HUMIDITY',
  SET_IS_IDLE_HUMIDITY_ENABLED: 'humidifierActionTypes/SET_IS_IDLE_HUMIDITY_ENABLED',
  SET_HUMIDIFIER_DOOR_STATUS: 'humidifier/SET_HUMIDIFIER_DOOR_STATUS',
  SET_HUMIDIFIER_RUNTIME: 'humidifierActionTypes/SET_HUMIDIFIER_RUNTIME',
  SET_HUMIDIFIER_ERROR: 'humidifierActionTypes/SET_HUMIDIFIER_ERROR',
  SET_IS_WATER_LEVEL_LOW: 'humidifierActionTypes/SET_IS_WATER_LEVEL_LOW',
  SET_IS_HUMIDIFIER_CONNECTED: 'humidifierActionTypes/SET_IS_HUMIDIFIER_CONNECTED',
};
// #endregion humidifier

// #region banner
export const BannerActionTypes = {
  SHOW_BANNER: 'bannerActionTypes/SHOW_BANNER',
  HIDE_BANNER: 'bannerActionTypes/HIDE_BANNER',
};
// #endregion banner

// #region plate recognition
export const PlateRecognitionActionTypes = {
  SET_IS_PLATE_RECOGNITION_ENABLED: 'plateRecognitionActionTypes/SET_IS_PLATE_RECOGNITION_ENABLED',
  SET_IS_ALREADY_SCANNED_ALL_EMPTY_NESTS: 'plateRecognitionActionTypes/SET_IS_ALREADY_SCANNED_ALL_EMPTY_NESTS',
  SET_IS_ALL_PLATES_SCANNED: 'plateRecognitionActionTypes/SET_IS_ALL_PLATES_SCANNED',
  SET_IS_ALL_PLATE_ALREADY_TRAINED: 'plateRecognitionActionTypes/SET_IS_ALL_PLATE_ALREADY_TRAINED',
  SET_IS_PLATE_EDIT_STATE_CHANGED: 'plateRecognitionActionTypes/SET_IS_PLATE_EDIT_STATE_CHANGED',
  RESTORE_PLATE_RECOGNITION_STATE: 'plateRecognitionActionTypes/RESTORE_PLATE_RECOGNITION_STATE',
  SET_IS_INCOMPATIBLE_VISION_VERSION: 'plateRecognitionActionTypes/SET_IS_INCOMPATIBLE_VISION_VERSION',
};
// #endregion plate recognition

// #region instrument
export const InstrumentActionTypes = {
  SET_IS_SIMULATION_MODE: 'instrumentActionTypes/SET_IS_SIMULATION_MODE',
  SET_IS_AUTOMATION_MODE: 'instrumentActionTypes/SET_IS_AUTOMATION_MODE',
  SET_ESTOP_TRIGGERED: 'instrumentActionTypes/SET_ESTOP_TRIGGERED',
  SET_INSTRUMENT_STATUS: 'instrumentActionTypes/SET_INSTRUMENT_STATUS',
  SET_INSTRUMENT_SERVICE_STATUS: 'instrumentActionTypes/SET_INSTRUMENT_SERVICE_STATUS',
  SET_LABWARE_SERVICE_STATUS: 'instrumentActionTypes/SET_LABWARE_SERVICE_STATUS',
  SET_MOTOR_ERROR_DATA: 'instrumentActionTypes/SET_MOTOR_ERROR_DATA',
  RESTORE_INSTRUMENT_STATE: 'instrumentActionTypes/RESTORE_INSTRUMENT_STATE',
};
// #endregion instrument
